import { POExportNoPerspectiveContainer } from "./container";

export const POExportNoPerspectivePage = () => {
  return <POExportNoPerspectiveContainer />;
};
